export default function ({ store, redirect }) {
  if (!helpers.isEmpty(store.state.auth.activeAccount) || !helpers.isEmpty(store.state.auth.active_pt)) {
    return redirect('/panel');
  }
}
